import React, { useState, useContext } from "react";
import { MobileContext } from "components/common";
import SettingsUpdatePhone from "./SettingsUpdatePhone";

const PhoneNumber = ({ user, next, setSuccess }) => {
  const [openUpdatePhone, setOpenUpdatePhone] = useState(false);
  const { isMobile } = useContext(MobileContext);

  const close = () => setOpenUpdatePhone(false);

  const handleNext = () => {
    close();
    if (isMobile) {
      next();
    } else {
      setSuccess();
    }
  };

  return <div className={`mb-4 flex ${isMobile ? "justify-center mt-4" : "justify-start"}`}>
    {
      openUpdatePhone ?
        (<SettingsUpdatePhone
          isOpen={openUpdatePhone}
          close={close}
          user={user}
          isMobile={isMobile}
          handleNext={handleNext}
        />) : (
          <button
            type="button"
            className="text-green-primary"
            onClick={() => setOpenUpdatePhone(true)}
          >
            Change Phone Number
          </button>
        )
    }
  </div>;
};

export default PhoneNumber;
